import { AvailableCategories, ProductCategoriesLink } from "components/Navbar/types"
import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { type ProductState, type ProductsCategory, type ProductType } from "./types"
import { type RootState } from "store/store"

const DEFAULT_CATEGORY_LABELS: Partial<Record<string, string>> = {
  GLASSES: "Glasses",
  MAKEUP: "Makeup",
}

const createDefaultProductsCategories = (): ProductsCategory[] =>
  AvailableCategories.filter((category) => category.enabled).map(({ name }) => ({
    label: DEFAULT_CATEGORY_LABELS[name] || name,
    to: ProductCategoriesLink[name] || ProductCategoriesLink.MAKEUP,
  }))

const createInitialState = (): ProductState => ({
  productsCategories: createDefaultProductsCategories(),
  productsCategoriesLoading: false,
  product: null,
  types: [],
})

const initialState: ProductState = createInitialState()

export const productsSlice = createSlice({
  name: "currentProduct",
  initialState,
  reducers: {
    setProductsCategories: (state, action: PayloadAction<ProductsCategory[]>) => {
      state.productsCategories = action.payload.map((category) => ({
        label: category.label,
        to: category.to || ProductCategoriesLink.MAKEUP,
      }))
    },
    setProductsCategoriesLoading: (state, action: PayloadAction<boolean>) => {
      state.productsCategoriesLoading = action.payload
    },
    setCurrentProduct: (state, action: PayloadAction<any>) => {
      state.product = action.payload
    },
    clearProductSlice: () => {
      return createInitialState()
    },
    setTypes: (state, action: PayloadAction<ProductType[]>) => {
      state.types = action.payload
    },
  },
})

export const {
  setCurrentProduct,
  clearProductSlice,
  setProductsCategories,
  setProductsCategoriesLoading,
  setTypes,
} = productsSlice.actions

export const selectTypes = (state: RootState) =>
  state.products.types.filter(
    (type) =>
      type.name !== "EYELASHES" &&
      (parseInt(type.id) <= 18 || type.name.includes("FOUNDATION") || type.name.includes("POWDER"))
  )

export default productsSlice.reducer
